import { css } from '@emotion/core'
import { colors, font, measures } from 'styles/variables'

const { unit } = measures

export const mobileContainer = css`
  background-color: ${colors.grays.gray6} !important;
  min-height: 100vh;
  min-height: 100dvh; /* Use dynamic viewport height */
  height: 100vh;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  z-index: 1000;
  overflow: hidden;

  /* Handle safe areas for mobile devices */
  padding-top: env(safe-area-inset-top);
  padding-bottom: env(safe-area-inset-bottom);
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);

  /* Override any parent container backgrounds */
  &::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${colors.grays.gray6};
    z-index: -1;
  }

  /* Ensure no default background colors from browser */
  * {
    background-color: inherit;
  }
`

export const header = css`
  display: flex;
  align-items: center;
  padding: ${6 * unit}px ${4 * unit}px ${6 * unit}px;
  position: relative;
  flex-shrink: 0;
  margin-top: ${1.8 * unit}px;
`

export const backArrow = css`
  color: #ffffff;
  font-size: 22px;
  cursor: pointer;
  user-select: none;
  position: absolute;
  left: ${4 * unit}px;
`

export const headerContent = css`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const title = css`
  color: ${colors.white12};
  font-size: 22px;
  font-weight: ${font.weight.bold};
  font-style: italic;
  margin: 0;
  line-height: 1.2;
  text-align: center;
  background: transparent !important;
  background-color: transparent !important;
  display: block;
`

export const formContainer = css`
  flex: 1;
  padding: 0 ${4 * unit}px ${2 * unit}px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`

export const form = css`
  flex: 1;
  display: flex;
  flex-direction: column;
`

export const inputField = css`
  background-color: transparent;

  /* Style the input labels */
  label {
    color: ${colors.white100} !important;
    font-size: 16px;
    margin-bottom: ${unit}px;
  }

  /* Style the input elements */
  input {
    background-color: transparent !important;
    border: 1px solid ${colors.grays.gray4} !important;
    border-radius: 8px !important;
    padding: ${2 * unit}px ${1.5 * unit}px !important;
    color: ${colors.white100} !important;
    font-size: 16px !important;

    &::placeholder {
      color: ${colors.grays.gray2} !important;
      font-size: 13px !important;
    }

    &:focus {
      border-color: ${colors.white100} !important;
      outline: none !important;
    }
  }
`

export const resetPasswordContainer = css`
  text-align: center;
  margin-bottom: ${2 * unit}px;
`

export const resetPasswordText = css`
  color: ${colors.grays.gray3};
  font-size: 12.8px;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: ${colors.white100};
  }
`

export const spacer = css`
  flex: 0.85;
`

export const buttonContainer = css`
  margin-top: ${1 * unit}px;
  padding: ${1 * unit}px 0 0 0;
  flex-shrink: 0;
`

export const continueButton = css`
  width: 100%;
  background-color: ${colors.greens.green2} !important;
  border: none !important;
  border-radius: 50px !important;
  height: 48px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  cursor: pointer;
  transition: background-color 0.2s ease !important;
  box-shadow: 0 0 0 transparent !important;

  &:hover {
    background-color: ${colors.greens.green3} !important;
  }

  &:active {
    background-color: ${colors.greens.green4} !important;
  }

  &:disabled {
    background-color: ${colors.grays.gray4} !important;
    cursor: not-allowed;
  }
`

export const buttonText = css`
  color: black !important;
  font-size: 13px !important;
  font-weight: ${font.weight.semiBold} !important;
  margin: 0 !important;
  text-transform: none !important;
`

export const homeIndicator = css`
  display: none;
`

export const progressContainer = css`
  padding: ${2 * unit}px ${4 * unit}px ${4 * unit}px;
  display: flex;
  justify-content: center;
  background: transparent;
`

export const separator = css`
  display: flex;
  align-items: center;
  text-align: center;
  margin: ${1 * unit}px 0;

  &::before,
  &::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid ${colors.grays.gray4};
  }

  &::before {
    margin-right: 0.5em;
  }

  &::after {
    margin-left: 0.5em;
  }
`

export const separatorText = css`
  font-size: 13px;
  color: ${colors.grays.gray3};
`

export const googleButtonContainer = css`
  margin-top: ${1 * unit}px;
  flex-shrink: 0;
`

export const googleButton = css`
  width: 100%;
  background-color: transparent !important;
  border: 1px solid ${colors.grays.gray4} !important;
  border-radius: 50px !important;
  height: 48px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  cursor: pointer;

  &:hover {
    background-color: ${colors.grays.gray5} !important;
  }
`

export const googleIcon = css`
  margin-right: 12px;
  font-size: 18px;
  color: white;
`

export const googleButtonText = css`
  color: white !important;
  font-size: 13px !important;
  font-weight: ${font.weight.semiBold} !important;
  margin: 0 !important;
  text-transform: none !important;
`
